export default "__VITE_ASSET__5cZ6ysHu__"